import React from 'react';
import MainStore from './mainStore';
import PbStore from './problemAssistant';
import FrStore from './faultReport';

const mainStore = new MainStore();
const pbStore = new PbStore();
const frStore = new FrStore();

const storesContext = React.createContext({
  mainStore,
  pbStore,
  frStore,
});

// 将mainStore直接暴露出去，可以用在其他非函数组件的地方
export const mainStoreWithoutHook = mainStore;
export default storesContext;

export const useStores = () => React.useContext(storesContext);
